/**
 * WordPress dependencies
 */
import { createContext } from '@safe-wordpress/element';

/**
 * Internal dependencies
 */
import type { CircularOptionPickerContextProps } from './types';

export const CircularOptionPickerContext =
	createContext< CircularOptionPickerContextProps >( {} );
